import loadable from '@loadable/component';
import Loading from '../components/Loader';

const VerifyEmail = loadable(
  () => import(/* webpackChunkName: "verify" */ '../containers/VerifyEmail'),
  { fallback: Loading }
);

VerifyEmail.needs = () => {
  VerifyEmail.preload();
};

export default VerifyEmail;
